import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PermitTypeChoice } from '../../../components/permit/permit-type-chooser/permit-type-chooser.component';

/**
 * /apply/recreation-choose - the split between the two kinds of recreation permit.
 *
 * Recreation is one card on the Apply page, but the two paths want different information
 * (road sites are charged per vehicle, boat-access sites per person), so this asks which
 * before sending the applicant to the matching info page. Reuses the permit-type chooser's
 * cards for a consistent look.
 */
@Component({
    selector: 'app-recreation-chooser',
    templateUrl: './recreation-chooser.component.html',
    styleUrls: ['./recreation-chooser.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class RecreationChooserComponent {
    public readonly choices: PermitTypeChoice[] = [
        { icon: 'fa-campground', label: 'Camping or day-use (road access)', route: '/recreation-area' },
        { icon: 'fa-anchor', label: 'Boat access', route: '/boat-access' },
    ];
}
